// `steps` and note text carry inline markup, authored here and never user input.
export default function setupGuides(mcpUrl) {
  const terminalLead = 'One command and you are done. Your browser opens so you can approve the sign-in.';

  return [
    {
      key: 'claude',
      label: 'Claude',
      paths: [
        {
          key: 'app',
          icon: 'desktop_windows',
          title: 'Claude web or app',
          steps: [
            'Open <b>Customize → Connectors</b>, click <b>+</b>, and search for <b>Hubstaff</b>',
            'Click <b>Connect</b>',
            'Approve access if asked',
          ],
          note: {
            title: 'On Claude Team or Enterprise?',
            text: 'A Claude owner adds Hubstaff first in <b>Organization settings → Connectors → Browse connectors</b>, '
              + 'then clicks <b>Add to your team</b>. After that, each person connects with the steps above. '
              + 'Until then, members see <b>Request</b> instead of <b>Connect</b>.',
          },
        },
        {
          key: 'cli',
          icon: 'terminal',
          title: 'Claude Code',
          lead: terminalLead,
          copy: {
            label: 'Run in your terminal',
            value: `claude mcp add --transport http hubstaff ${mcpUrl}`,
          },
        },
      ],
    },
    {
      key: 'chatgpt',
      label: 'ChatGPT',
      paths: [
        {
          key: 'app',
          icon: 'desktop_windows',
          title: 'ChatGPT web or app',
          steps: [
            'Open <b>Plugins</b> and search for <b>Hubstaff</b>',
            'Click <b>Install</b>',
            'Approve access if asked',
          ],
          note: {
            title: 'On ChatGPT Enterprise or Edu?',
            text: 'A ChatGPT admin turns on Hubstaff first in <b>Admin console → Plugins</b>. '
              + 'After that, each person installs it with the steps above.',
          },
        },
        {
          key: 'cli',
          icon: 'terminal',
          title: 'Codex',
          lead: terminalLead,
          copy: {
            label: 'Run in your terminal',
            value: `codex mcp add hubstaff --url ${mcpUrl}`,
          },
        },
      ],
    },
    {
      key: 'other',
      label: 'Other apps',
      note: {
        title: 'Every app names this screen differently',
        text: 'Look for Connectors, MCP servers, Plugins, or Integrations in the app’s settings. '
          + 'In Cursor, add the entry to <code>~/.cursor/mcp.json</code>.',
      },
      paths: [
        {
          key: 'app',
          icon: 'settings',
          title: 'Set it up in your app',
          steps: [
            'Find where the app adds an MCP server or custom connector',
            'Choose the remote, URL, or streamable HTTP option, not a local command',
            'Paste the Hubstaff address',
            'Approve the Hubstaff sign-in in your browser',
          ],
          copy: { label: 'Hubstaff MCP address', value: mcpUrl },
        },
      ],
    },
  ];
}
